module.exports = __webpack_public_path__ + "static/media/magsatndsubscribe.cd2ba171.png";